import { AnalyticsApi, AnalyticsEvent } from '@backstage/core-plugin-api';

export class CompositeAnalyticsClient implements AnalyticsApi {
  private readonly clients: AnalyticsApi[];

  constructor(...clients: AnalyticsApi[]) {
    this.clients = clients;
  }

  public captureEvent(event: AnalyticsEvent): void {
    for (const client of this.clients) {
      client.captureEvent(event);
    }
  }
}
